import { getCoreRowModel, useReactTable, getFilteredRowModel, getSortedRowModel, getPaginationRowModel, RowData } from "@tanstack/react-table"
import { Table } from "react-bootstrap"
import Head from "./Head"
import Body from "./Body"
import Foot from "./Foot"
import { TablePagination } from "../Pagination/PaginationAwayter.component"
import { DataGridProps } from "./DataGripProps"
import { smartFilter } from "./Filters"
import "./DataGrid.css"

declare module "@tanstack/react-table" {
    interface ColumnMeta<TData extends RowData = RowData, TValue = unknown> {
        filterOptions?: { label: string; value: any }[]
    }
}

/**
 * Taula feta amd headless ui de tanstack react i amb estils de bootstrap
 * Cal tenir definit --accent-color per a uns bons estils
 *
 * Nota: Si es produeixen rerenders infinits, pot ser degut a `data`, `columns` o estats (`sorting`,`pagination`...etc)
 * sense referència estable (p. ex. constants declarades dins el mateix component).
 *
 * Vegeu: https://tanstack.com/table/latest/docs/faq#how-do-i-stop-infinite-rendering-loops
 *
 */
function DataGrid<T extends object>(props: DataGridProps<T>) {
    const { data, columns, manual = false, columnFilters, onColumnFiltersChange, sorting, onSortingChange, paginationEnabled = true, pageCount, filtersPlaceholder, globalFilter, onGlobalFilterChange, onRowClick } = props
    let pagination // No és súper elegant però evita un nombre més gran de ifs
    let onPaginationChange
    if (props.paginationEnabled !== false) {
        pagination = props.pagination
        onPaginationChange = props.onPaginationChange
    }
    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getSortedRowModel: getSortedRowModel(),
        ...(paginationEnabled && { getPaginationRowModel: getPaginationRowModel() }),

        defaultColumn: {
            filterFn: smartFilter
        },
        state: {
            ...(columnFilters && { columnFilters }),
            ...(sorting && { sorting }),
            ...(pagination && { pagination }),
            ...(globalFilter && { globalFilter })
        },
        ...(columnFilters && { onColumnFiltersChange }),
        ...(sorting && { onSortingChange }),
        ...(pagination && { onPaginationChange }),
        ...(globalFilter && { onGlobalFilterChange }),
        manualFiltering: manual,
        manualSorting: manual,
        manualPagination: manual,
        ...(manual && pagination && { pageCount: pageCount ?? -1 })
    })

    return (
        <div className='aw-data-grid-container'>
            <div className='aw-table-container'>
                <Table className='aw-data-grid'>
                    <Head table={table} searchPlaceholder={filtersPlaceholder} />
                    <Body table={table} onRowClick={onRowClick} />
                    {/*<Foot table={table} /> Si mai es necessita es pot afegir, però he vist que de moment a la demo no hi ha cap footer*/}
                </Table>
            </div>
                    {paginationEnabled && (<TablePagination table={table} />)}
        </div>
    )
}

export default DataGrid
